import axios from "axios";
import { attachAuthInterceptor } from "./authInterceptor";

const profileClient = axios.create({
  baseURL: import.meta.env.VITE_PROFILE_API_DOMAIN,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(profileClient);

export default profileClient;
